import { Box, xcss } from '@atlaskit/primitives';
import { messages } from '@databases/intl/messages';
import React from 'react';
import { FormattedMessage } from 'react-intl-next';

import type { AiFieldCellLoadingPhase } from './use-ai-field-cell-loading-state';

const thinkingStyles = xcss({
  color: 'color.text.subtlest'
});

export type AiFieldThinkingPlaceholderProps = {
  loadingState: AiFieldCellLoadingPhase;
};

export const AiFieldThinkingPlaceholder = ({
  loadingState
}: AiFieldThinkingPlaceholderProps) => {
  const message =
    loadingState === 'summarizing'
      ? messages['field-value.ai-field-summarizing']
      : messages['field-value.ai-field-almost-done'];

  return (
    <Box xcss={thinkingStyles}>
      <FormattedMessage {...message} />
    </Box>
  );
};
